<template>
<button class="mdc-button mdc-button--raised bk-button"
        ref="forwardButton"
        @click="$emit('click')"
        :disabled="disabled"
>
  <div class="mdc-button__ripple"></div>
  <span class="mdc-button__label">
    <slot />
  </span>

</button>
</template>
<script>
import { MDCRipple } from '@material/ripple'

export default {
  name: "bk-button",
  props: {
    /**
     * If true the button is disabled
     */
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  mounted () {
    new MDCRipple(document.querySelector('.mdc-button'))
  },
}
</script>
<style lang="scss" scoped>
  @import "../scss/colors";
  @import "../../node_modules/@material/button/mdc-button";

  .bk-button {
    width: 100%;
    max-width: 320px;
  }
</style>
